import React from 'react';
import { useTask } from '../../context/TaskContext';
import TaskItem from './TaskItem';
import { FaTasks } from 'react-icons/fa';
import './TaskList.css';

const TaskList = () => {
  const { tasks, loading } = useTask();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading tasks...</p>
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div className="empty-state card">
        <FaTasks className="empty-icon" />
        <h3>No tasks found</h3>
        <p>Create your first task to get started!</p>
      </div>
    );
  }

  return (
    <div className="task-list">
      <div className="task-list-header">
        <h3>Your Tasks ({tasks.length})</h3>
      </div>
      
      <div className="task-grid">
        {tasks.map(task => (
          <TaskItem key={task._id} task={task} />
        ))}
      </div>
    </div>
  );
};

export default TaskList;
